export default {
    settings: 'setting',
    languages: 'languages',
    getFirstData: "getFirstData"
}